import styled from '@emotion/styled'
import * as React from 'react'

import { Networks, useWhitelabel } from 'main/framework'
import { spacing, Text } from 'main/ui'

const Container = styled.div`
  max-width: 300px;
  display: flex;
  flex-direction: column;

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(1)}px;
  }
`

export default function Tooltip() {
  const whitelabel = useWhitelabel()

  const copy = copyLookup(whitelabel.networkAbbr)

  return (
    <Container>
      <Text>{copy.firstSection}</Text>
      <Text>{copy.secondSection}</Text>
    </Container>
  )
}

function copyLookup(abbr: string | undefined): {
  firstSection: string
  secondSection: string
} {
  switch (abbr) {
    case Networks.ELI:
      return {
        firstSection:
          'Every program has unique pricing, and prices may vary based on your child’s age. Many programs accept vouchers, including Child Care and Development Fund (CCDF) and On My Way Pre-K.',
        secondSection:
          'Others may offer additional discounts and payment options. You should reach out to specific programs if you have tuition questions.',
      }
    case Networks.NM:
      return {
        firstSection:
          'Every program has unique pricing, and prices may vary based on your child’s age. Many programs accept Childcare Assistance, including Child Care and Development Fund (CCDF) and On My Way Pre-K.',
        secondSection:
          'Others may offer additional discounts and payment options. You should reach out to specific programs if you have tuition questions.',
      }
    default:
      return {
        firstSection:
          'Keep in mind that prices may vary between children age groups. Most programs charge more for infants (under 2), but every program is unique.',
        secondSection:
          'While not all programs support weekly payment, we recommend reaching out to directors with your preference. If you wish to pay via subsidy, tuition will be processed monthly.',
      }
  }
}
